import { render, staticRenderFns } from "./Event.html?vue&type=template&id=e358a304&scoped=true&external"
import script from "./Event.vue?vue&type=script&lang=js"
export * from "./Event.vue?vue&type=script&lang=js"
import style0 from "./Event.scss?vue&type=style&index=0&id=e358a304&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e358a304",
  null
  
)

export default component.exports